module.exports = __webpack_public_path__ + "img/replying.409b08f6.png";